/**
 * Wipes the browser's localStorage + sessionStorage but keeps a small set
 * of UI preference keys around. Used by both the explicit Sign Out
 * button and the 401-redirect fallbacks so users don't lose their
 * dashboard layout / column visibility every time their token expires.
 */

const PRESERVE_KEYS = [
    'hp_widget_order',
    'hp_widget_visibility',
    'dashboard_widget_order',
    'dashboard_widget_visibility',
    'lp_housing_pro_mode',
];

const PRESERVE_PREFIXES = [
    // Per-property certificate column visibility (`certVisibility_<id>`).
    'certVisibility_',
];

export function clearSessionPreservingPreferences() {
    const preserved: Record<string, string> = {};

    for (const k of PRESERVE_KEYS) {
        const v = localStorage.getItem(k);
        if (v != null) preserved[k] = v;
    }
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (!key) continue;
        if (PRESERVE_PREFIXES.some(p => key.startsWith(p))) {
            const v = localStorage.getItem(key);
            if (v != null) preserved[key] = v;
        }
    }

    localStorage.clear();
    sessionStorage.clear();

    for (const [k, v] of Object.entries(preserved)) {
        localStorage.setItem(k, v);
    }
}
